import { type InputHTMLAttributes, forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { Input } from './styles';

type InputType = 'number' | 'password' | 'text';

interface IFormInputTextProps extends InputHTMLAttributes<HTMLInputElement> {
  dataCy?: string;
  type: InputType;
  name: string;
}

export const FormInputText = forwardRef<HTMLInputElement, IFormInputTextProps>(
  // eslint-disable-next-line no-restricted-syntax
  function FormInputText(
    { dataCy, type: inputType = 'text', name, ...inputProps },
    ref
  ): JSX.Element {
    const { register } = useFormContext();

    return (
      <Input
        // @ts-expect-error: 'ref' is specified more than once, so this usage will be overwritten.
        ref={ref}
        {...inputProps}
        {...register(name, {
          valueAsNumber: inputType === 'number',
        })}
        type={inputType}
        data-cy={dataCy}
      />
    );
  }
);
